import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAdminSession, sendMagicLink, signOutAdmin } from "@/lib/adminAuth";

function LoginGate() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError("");
    try {
      await sendMagicLink(email.trim());
      setSent(true);
    } catch (err) {
      setError(err.message || "লিংক পাঠানো যায়নি");
    }
    setSending(false);
  };

  if (sent) {
    return (
      <div className="container py-20 max-w-sm text-center">
        <p className="text-foreground font-medium mb-1">লিংক পাঠানো হয়েছে</p>
        <p className="text-muted-foreground text-sm">{email}-এ একটা সাইন-ইন লিংক গেছে, ইমেইল খুলে সেটায় ক্লিক করো।</p>
      </div>
    );
  }

  return (
    <div className="container py-20 max-w-sm">
      <h1 className="font-display text-xl font-semibold text-foreground mb-4 text-center">অ্যাডমিন লগইন</h1>
      <form onSubmit={submit} className="space-y-3">
        <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ইমেইল" />
        <Button type="submit" className="w-full" disabled={sending}>
          {sending && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
          সাইন-ইন লিংক পাঠাও
        </Button>
        {error && <p className="text-sm text-destructive text-center">{error}</p>}
      </form>
    </div>
  );
}

function AccessDenied({ email, adminOnly }) {
  return (
    <div className="container py-20 max-w-sm text-center">
      <p className="text-foreground font-medium mb-1">এই একাউন্টের অ্যাক্সেস নেই</p>
      <p className="text-muted-foreground text-sm mb-4">
        {adminOnly
          ? `${email} অ্যাডমিন নয় — এই পেজ শুধু অ্যাডমিনের জন্য।`
          : `${email}-এর মডারেশনের অনুমতি নেই। অনুমতি পেতে অ্যাডমিনকে বলো তোমার role বদলে দিতে।`}
      </p>
      <Button variant="outline" onClick={signOutAdmin}>
        সাইন-আউট করো
      </Button>
    </div>
  );
}

const tabClass = ({ isActive }) =>
  `text-sm px-3 py-1.5 rounded-md transition-colors ${isActive ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground"}`;

// অ্যাডমিনের সব পেজের মাথার সারি: শিরোনাম + ট্যাব + সাইন-আউট
export function AdminNav({ isAdmin }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
      <div className="flex flex-wrap items-center gap-2">
        <h1 className="font-display text-2xl font-semibold text-foreground mr-2">অ্যাডমিন</h1>
        <NavLink to="/admin" end className={tabClass}>
          রিভিউ
        </NavLink>
        {isAdmin && (
          <NavLink to="/admin/categories" className={tabClass}>
            ক্যাটাগরি
          </NavLink>
        )}
      </div>
      <Button variant="outline" size="sm" onClick={signOutAdmin}>
        সাইন-আউট
      </Button>
    </div>
  );
}

// লগইন/অনুমতি পরীক্ষা সেরে children({ isAdmin }) দেখায়। adminOnly = moderator-ও ঢুকতে পারবে না।
export default function AdminGate({ adminOnly = false, children }) {
  const { loading, isStaff, isAdmin, email } = useAdminSession();

  if (loading) {
    return (
      <div className="container py-20 flex justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!email) return <LoginGate />;
  if (adminOnly ? !isAdmin : !isStaff) return <AccessDenied email={email} adminOnly={adminOnly} />;
  return children({ isAdmin });
}
